import React from "react"
import dayjs from "dayjs"
import { cn } from "lib/utils"
import { useRenderStyling } from 'lib/hooks/useRenderStyling';
import { TrxDetailBlock, TrxDetailHeader, TrxDetailDataElement } from "."


export default function DetailScreenActionsInfo({
  screen,
  renderPkg
}:{
  screen:any
  renderPkg:any
}){

  const capitalize =(str:string) => str.charAt(0).toUpperCase() + str.slice(1)

  const actionsWrapper = useRenderStyling("w-full flex mt-4 justify-start items-start pb-3", "styleObj")
  const textBold = useRenderStyling("text-base font-bold", "styleObj")
  const textNormal = useRenderStyling("text-base font-normal", "styleObj")

  return (
    <TrxDetailBlock>
      <TrxDetailHeader title="Actions" />
      <div {...actionsWrapper}>
        <div 
          style={{
            width: "75%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: "0.25rem",
            padding: "0.5rem 0.5rem",
          }}
        >
          <div 
            style={{
              width: "16.66667%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "1.5rem",
              backgroundColor: screen.action.actionType === "refund" ? "#fca5a5" : "#bbf7d0",
              color: "#000000",
              fontSize: "0.75rem",
              borderRadius: "0.375rem",
              textTransform: "uppercase",
            }}
          >
            <span>{capitalize(screen.action.actionType === "capture" ? "success" : screen.action.actionType )}</span>
          </div>
          <div style={{ width: "66.66667%", display: "flex", flexDirection: "column", paddingLeft: ".25rem" }}>
            <span {...textBold}>Card {capitalize(screen.action.actionType)}</span>
            <span {...textNormal}>{dayjs(screen.action.date).format("MMM DD, YYYY HH:MM:ss a")}</span>
          </div>
        </div>

        <div style={{ width: "33.33333%", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-end", paddingRight: "0.5rem" }}>
            <span {...textNormal}><span {...textBold}>{screen.action.amt}</span> {screen.action.currency}</span>
            <div 
              style={{
                width: "66.66667%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "1.5rem",
                backgroundColor: "#93c5fd",
                border: "1px solid #3b82f6",
                borderRadius: "0.375rem",
                color: "#000000",
                fontSize: "0.75rem",
                textTransform: "uppercase",
              }}
            >
              <span>Show Details</span>
            </div>
          </div>
      </div>
    </TrxDetailBlock>
  )
}